module.exports = __webpack_public_path__ + "media/images/icon-lsd-arrow-down-c10b6f9828efdd994d6fae2c57fc09bb.svg";